import { uuid } from 'vue-uuid'
import { mapActions, mapGetters, mapState } from 'vuex'

const isImage = (file_name) => {
  return (/\.(gif|jpe?g|tiff?|png|webp|bmp)$/i).test(file_name)
}

export default {
  data() {
    return {
      uploadingList: [],
    }
  },

  computed: {
    ...mapState('document', {
      files: 'files',
    }),
    ...mapGetters({
      getAppCurrent: 'getAppCurrent',
    }),
    mapImages() {
      return this.files.filter((file) => isImage(file.file_name))
    },
    mapOtherFiles() {
      return this.files.filter((file) => !isImage(file.file_name))
    },
    mapUploadingList() {
      const arr = this.uploadingList.reverse()
      return arr
    },
    mapUploadingImages() {
      return this.mapUploadingList.filter((file) => isImage(file.file_name))
    },
    mapUploadingOtherFile() {
      return this.mapUploadingList.filter((file) => !isImage(file.file_name))
    },
  },

  async mounted() {
    await this.fetchFileList()
  },

  methods: {
    ...mapActions('document', {
      getAttachFileList: 'getAttachFileList',
      createAttachFile: 'createAttachFile',
      deleteAttachFile: 'deleteAttachFile',
    }),
    fetchFileList() {
      return this.getAttachFileList({
        ref_doc: this.refDoc,
        ref_id: this.refId,
      })
    },
    removeFileBy(id) {
      this.uploadingList = this.uploadingList.filter((file) => file.id !== id)
    },
    async handleUploadFile(file) {
      if (file) {
        const id = uuid.v1()
        this.uploadingList.push({
          id,
          file_name: file.name,
        })
        const formData = new FormData()
        formData.append('file', file)
        formData.append('file_name', file.name)
        formData.append('ref_doc', this.refDoc)
        formData.append('ref_id', this.refId)
        formData.append('app_id', this.getAppCurrent.app_id)
        formData.append('module_id', this.getAppCurrent.module_id)
        const response = await this.createAttachFile(formData)
        if (response.success) {
          this.removeFileBy(id)
          await this.fetchFileList()
          this.notify(this.$vs, {
            text: this.$t('message.uploadfilesuccess'),
            color: 'success',
            icon: 'cloud',
          })
        }
      }
    },
    handleClickDeleteFile(index, file) {
      this.modalConfirmDelete.show = true
      this.confirmDeleteType = 'file'
      this.confirmDeleteFileId = file._id
    },
    async onDeleteFile(fileId) {
      this.modalConfirmDelete.loading = true
      const response = await this.deleteAttachFile(fileId)
      if (response.success) {
        await this.fetchFileList()

        this.modalConfirmDelete.loading = false
        this.modalConfirmDelete.show = false
        this.notify(this.$vs, {
          text: this.$t('message.deletefilesuccess'),
          color: 'danger',
          icon: 'delete',
        })
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/docRefFile.js